module.exports = __webpack_public_path__ + "img/55.6edf8bf0.jpg";